/* eslint-disable no-console */
import { diff } from 'jest-diff';

// Strip ANSI escape codes that jest-diff adds for terminal coloring.
// eslint-disable-next-line no-control-regex
const ANSI_REGEX = /\u001b\[[0-9;]*m/g;
const stripAnsi = (str = '') => String(str ?? '').replace(ANSI_REGEX, '');

const LINE_STYLES = {
  '+': 'color: #22c55e;', // added — green
  '-': 'color: #ef4444;', // removed — red
  '@': 'color: #a855f7; font-weight: bold;', // hunk header — purple
};
const DEFAULT_STYLE = 'color: inherit;';

const logColorizedDiff = (diffString = '') => {
  const lines = stripAnsi(diffString).split('\n');
  const formatParts = [];
  const styleParts = [];

  lines.forEach((line) => {
    const style = LINE_STYLES[line[0]] ?? DEFAULT_STYLE;
    formatParts.push(`%c${line}`);
    styleParts.push(style);
  });

  console.log(formatParts.join('\n'), ...styleParts);
};

export const diffEmsData = (objA, objB) => {
  console.log('Comparing window.emsData and window.convertedBootstrapData');
  const expected = 'expected (window.convertedBootstrapData)';
  const received = 'received (window.emsData)';

  console.log(`%c${expected}`, 'color: #ef4444; font-weight: bold;');
  console.log(`%c${received}`, 'color: #22c55e; font-weight: bold;');

  const result = diff(objA, objB, { expand: false });
  if (typeof result === 'string') {
    logColorizedDiff(result);
  } else {
    console.log(result);
  }
  return result;
};
